<div class="dtf-dashboard">
    <!--Announcement Banner Code-->
    <div class="dtf-alertpage"></div>

    

  <div *ngIf="(this.bodyLoaded)" class="mbfs-payoff-quote-spinner">

    <!--Default page to load while waiting for Redirection to Classic-->
    <section class="mbfs-home-hero"  style="background-image: url(/static/assets/img/dtf-assets/images/redesign/mbfs_top_image_and_tint.jpg);">
      <section class="mbfs-home-hero__header">
       <h2 class="mbfs-home-hero__header-subtitle">
        {{ 'LoaderPages.BannerHeader' | translate }}
        </h2>
        <p class="mbfs-home-hero__header-text-demi">
          {{ 'LoaderPages.Loading' | translate }}
        </p>

        <!--Spinner-->
        <div class="mbfs-loading-spinner-overlay"></div>
        <div class="mbfs-loading-spinner"> </div>
      </section>
    </section>
  </div>

  <!--US HTML page-->
  <div class="container_dashboard" *ngIf="!this.bodyLoaded && !isCanadaPortal && !isTerminatedAccounts">
    <div class="dtfbrochures__containerlong">
      <div class="row4">
        <div class="dynamicflexbox">
        <div style="text-align: right;">
          <a (click)="clickvideo('viewAccounts');" href="javascript:void(0);" > <img style="width: 30px;" src="/static/assets/img/dtf-assets/images/redesign/DTF_Website_VideoHelpButton.png"></a>
        </div>

          <section class="section">
            <div class="section__item section__item--start">
                <h4 class="dtfbrochures__header5">{{ 'Dashboard.NumAccounts' | translate }}</h4>
                <div style="margin-left: 40px;" *ngIf="newAccount">
                  <img matSuffix class="example-form-img" src="static/assets/img/dtf-assets/images/DTF_Icons/NewFlag.png">
                </div>
                <h3 class="dtfbrochures__header7">{{this.recAccCount}}</h3>
                <button type="submit" (click)="checkUrl('account')" [routerLink]="[]" class="mbfs-button">{{ 'Dashboard.AdditionalDetails' | translate }}</button>
            </div>
            <div class="section__item section__item--end">
                <h4 class="dtfbrochures__header5">{{ 'Dashboard.CurrentDue' | translate }}</h4>
                <h3 class="dtfbrochures__header6">${{this.totalDue}}</h3><!--{{'Dashboard.CurrentDueValue'}}-->
                <!--Replace a number here variable should be added here refer dtfhome-->
                <!-- <button type="submit" *ngIf="lessAccounts"   (click)="checkUrl('pay')" class="mbfs-button">{{ 'Dashboard.PayNowButton' | translate }}</button> -->
                <button *ngIf="DTPAY && getTotalDueValue() > 0" type="submit" (click)="checkUrlPay('onlinepayment')" class="mbfs-button">{{ 'Dashboard.PayNowButton' | translate }}</button>
            </div>
          </section>
        </div>
      </div>
    </div>

   <!-- <div class="dtfbrochures__containerlong3">
    <div class="dynamicflexbox">
       <section class="section1">
          <div class="section__item section__item--start"></div>
          <div class="section__item section__item--end" *ngIf="!isCanadaPortal">
            <h4 class="dtfbrochures__header4" style="color: white;"> {{ 'Dashboard.NewAccountTitle' | translate }}</h4>
            <p class="dtfbrochures__paragraph2" style="color: white;">{{ 'Dashboard.NewAccountCopy' | translate }} </p>
          </div>
          <div class="section__item section__item--end" *ngIf="isCanadaPortal">
            <h4 class="dtfbrochures__header4" style="color: white;"> {{ 'Dashboard.NewAccountTitle' | translate }}</h4>
            <p class="dtfbrochures__paragraph2" style="color: white;">{{ 'Dashboard.NewAccountCopy' | translate }} </p>
          </div>
       </section>
    </div>
 </div> -->

   <div class="row">
    <div class="col-sm-6">
       <div class="">
          <div class="card-body1">
            <div style="text-align: right;">
            <a (click)="clickvideo('autopay');" href="javascript:void(0);" > <img style="width: 30px;" src="/static/assets/img/dtf-assets/images/redesign/DTF_Website_VideoHelpButton.png"></a>
            <h4 class="dtfbrochures__title">{{ 'Dashboard.AutopayTitle' | translate }} </h4>
            </div>
            <div class="row">
                <img class="iconimage3" src="static/assets/img/dtf-assets/images/redesign/Manage-AutoPay-Icon.png">
                <h4 class="dtfbrochures__header3">{{ 'Dashboard.AutopayHeader' | translate }}</h4>
              </div>
             <div class="row2">
              <p class="dtfbrochures__paragraph1">{{ 'Dashboard.AutopayCopy' | translate }}</p>
              <button type="submit" (click)="checkUrl('autopay')" class="mbfs-button">{{ 'Dashboard.AutopayButton' | translate }}</button>
             </div>
             <div class="row2">
              <p></p>
              <button type="submit" (click)="checkUrl('ebill')" class="mbfs-button">{{ 'Dashboard.EbillButton' | translate }}</button>
             </div>
            
             <br>
          </div>
       </div>
    </div>
    <div class="col-sm-6">
       <div class="">
        <div class="card-body1" style="padding-bottom: 38px;">
          <div style="text-align: right;">
            <a (click)="clickvideo('amort');" href="javascript:void(0);" > <img style="width: 30px;" src="/static/assets/img/dtf-assets/images/redesign/DTF_Website_VideoHelpButton.png"></a>
           </div>
          <h4 class="dtfbrochures__title">{{ 'Dashboard.AmortTitle' | translate }} </h4>
          <div class="row">
                <img class="iconimage3" src="static/assets/img/dtf-assets/images/redesign/View-Amortization-Schedule-Icon.png">
                <h4 class="dtfbrochures__header3">{{ 'Dashboard.AmortHeader' | translate }}</h4>
             </div>
             <div class="row2">
              <p class="dtfbrochures__paragraph1">{{ 'Dashboard.AmortCopy' | translate }}</p>
              <button type="submit" (click)="checkUrl('amortization')" class="mbfs-button">{{ 'Dashboard.AmortButton' | translate }}</button>
             </div>
             <br>
          </div>
       </div>
    </div>
  </div>

  <!-- <div class="dtfbrochures__containerlong2" *ngIf="!isCanadaPortal">
    <div class="dynamicflexbox">
       <section class="section1">
          <div class="section__item section__item--start"></div>
          <div class="section__item section__item--end">
             <h4 class="dtfbrochures__header4" style="color: white;"> {{ 'LoginHeader.StatetoStateTransfer' | translate }}</h4>
             <p class="dtfbrochures__paragraph2" style="color: white;">{{ 'DocumentCenter.TitleTransferTitle' | translate }} </p>
             <button style="float: right;" type="submit" (click)="checkUrl('title state transfer')" class="mbfs-button">{{ 'DocumentCenter.Begin' | translate }}</button>
          </div>
       </section>
    </div>
  </div> -->

  <div class="row" style="margin-top: 6%; padding-left: 15px; padding-right: 15px;">
  <div class="card-body1">
    <div class="row align-items-center">
      
      <!-- Image -->
      <div class="col-12 col-md-6 text-center mb-3 mb-md-0">
        <img
          src="/static/assets/img/dtf-assets/images/redesign/connectedinsurance.png"
          alt="Logo"
          class="img-fluid logo"
        />
      </div>

      <!-- Content -->
      <div class="col-12 col-md-6">
        <div class="text-content">
          <h4 class="dtfbrochures__header4">Save with Connected Insurance</h4>
          <p class="dtfbrochures__paragraph2" style="color: black;">
            Freightliner® and Western Star® drivers can save up to 10%* on their insurance through Connected Insurance.
            Get your personalized quote today!
          </p>
        </div>
      
        <div class="action">
          <button (click)="checkUrl('connected-insurance')" class="mbfs-button">
            Learn More
          </button>
        </div>
      
        <small>*excluding fees and taxes</small>
      </div>
    </div>
  </div>
</div>
  <!-- <div *ngIf="Current">
    <div class="row">
      <div class="col-sm-6">
        <div class="card1">
          <div class="card-body1">
            <div style="text-align: right;">
            </div>
            <h4 class="dtfbrochures__title">{{ 'Dashboard.PayoffTitle' | translate }} </h4>
            <div class="row">
              <img class="iconimage3" src="static/assets/img/dtf-assets/images/redesign/Get-a-Payoff-Icon.png">
              <h4 class="dtfbrochures__header3">{{ 'Dashboard.PayoffHeader' | translate }}</h4>
            </div>
            <div class="row2">
              <p class="dtfbrochures__paragraph1">{{ 'Dashboard.PayoffCopy' | translate }}</p>
              <button type="submit" (click)="checkUrl('payoff')" class="mbfs-button">{{ 'Dashboard.PayoffButton' |
                translate
                }}</button>
            </div>
            <br>
          </div>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="card1">
          <div class="card-body1">
            <div style="text-align: right;">
            </div>
            <h4 class="dtfbrochures__title">{{ 'Dashboard.PaymentTitle1' | translate }} </h4>
            <div class="row">
              <img class="iconimage3" src="static/assets/img/dtf-assets/images/redesign/View-Payment-History-Icon.png">
              <h4 class="dtfbrochures__header3">{{ 'Dashboard.PaymentHeader1' | translate }}</h4>
            </div>
            <div class="row2">
              <p class="dtfbrochures__paragraph1">{{ 'Dashboard.PaymentCopy1' | translate }}</p>
              <button type="submit" (click)="paymenthistory()" class="mbfs-button">{{ 'Dashboard.PaymentButton1' |
                translate }}</button>
            </div>
            <br><br>
          </div>
        </div>
      </div>
    </div>
  </div> -->
    <div class="row">
      <div class="col-sm-6">
        <div class="">
          <div class="card-body1">
            <div style="text-align: right;">
              <!-- <a (click)="clickvideo('payoff');" href="javascript:void(0);" > <img style="width: 30px;" src="/static/assets/img/dtf-assets/images/redesign/DTF_Website_VideoHelpButton.png"></a> -->
            </div>
            <h4 class="dtfbrochures__title">{{ 'Dashboard.PayoffTitle' | translate }} </h4>
            <div class="row">
              <img class="iconimage3" src="static/assets/img/dtf-assets/images/redesign/Get-a-Payoff-Icon.png">
              <h4 class="dtfbrochures__header3">{{ 'Dashboard.PayoffHeader' | translate }}</h4>
            </div>
            <div class="row2">
              <p class="dtfbrochures__paragraph1">{{ 'Dashboard.PayoffCopy' | translate }}</p>
              <button type="submit" (click)="checkUrl('payoff')" class="mbfs-button">{{ 'Dashboard.PayoffButton' |
                translate
                }}</button>
            </div>
            <br>
          </div>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="">
          <div class="card-body1" style="padding-bottom: 26px;">
            <div style="text-align: right;">
              <!-- <a (click)="clickvideo('payment');" href="javascript:void(0);"> <img style="width: 30px;"
                            src="/static/assets/img/dtf-assets/images/redesign/DTF_Website_VideoHelpButton.png"></a> -->
            </div>
            <h4 class="dtfbrochures__title">{{ 'Dashboard.PaymentTitle' | translate }} </h4>
            <div class="row">
              <img class="iconimage3" src="static/assets/img/dtf-assets/images/redesign/View-Payment-History-Icon.png">
              <h4 class="dtfbrochures__header3">{{ 'Dashboard.PaymentHeader' | translate }}</h4>
            </div>
            <div class="row2">
              <p class="dtfbrochures__paragraph1">{{ 'Dashboard.PaymentCopy' | translate }}</p>
              <mat-form-field *ngIf="DTPAY" appearance="outline" style="width: 55%;">
                <mat-select placeholder="Select Option" [(ngModel)]="selectedRequest">
                  <mat-option *ngFor="let request of selectedRequests" [value]="request.value"
                    (click)="checkUrlPay(selectedRequest)">
                    {{request.viewValue }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <button *ngIf="!DTPAY" class="mbfs-button">Coming Soon</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row" style="margin-bottom: 3%;">
      <div class="col-sm-6">
        <div class="">
          <div class="card-body1">
            <div style="text-align: right;">
            <a (click)="clickvideo('invoice');" href="javascript:void(0);" > <img style="width: 30px;" src="/static/assets/img/dtf-assets/images/redesign/DTF_Website_VideoHelpButton.png"></a>
            </div>
            <h4 class="dtfbrochures__title">{{ 'Dashboard.InvoiceTitle' | translate }} </h4>
              <div class="row">
                  <img class="iconimage3" src="static/assets/img/dtf-assets/images/redesign/Doc-Request-Icon.png">
                  <h4 class="dtfbrochures__header3">{{ 'Dashboard.InvoiceHeader' | translate }}</h4>
              </div>
              <div class="row2">
                <p class="dtfbrochures__paragraph1">{{ 'Dashboard.InvoiceCopy' | translate }}</p>
                <!-- <button type="submit" (click)="checkUrl('invoice')" class="mbfs-button">{{ 'Dashboard.InvoiceButton' | translate }}</button> -->
                <button type="submit" (click)="checkUrl('documentcenter')" class="mbfs-button">{{ 'Dashboard.DocumentCenterButton' | translate }}</button>
              </div>
              <br><br>
            </div>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="">
          <div class="card-body1">
            <div style="text-align: right;">
            <a (click)="clickvideo('profile');" href="javascript:void(0);" > <img style="width: 30px;" src="/static/assets/img/dtf-assets/images/redesign/DTF_Website_VideoHelpButton.png"></a>
            </div>
            <h4 class="dtfbrochures__title">{{ 'Dashboard.ProfileTitle' | translate }} </h4>
              <div class="row">
                  <img class="iconimage3" src="static/assets/img/dtf-assets/images/redesign/Manage-Your-Profile-Icon.png">
                  <h4 class="dtfbrochures__header3">{{ 'Dashboard.ProfileHeader' | translate }}</h4>
              </div>
              <div class="row2">
                <p class="dtfbrochures__paragraph1">{{ 'Dashboard.ProfileCopy' | translate }}</p>
                <button type="submit" (click)="checkUrl('manageYourProfile')" class="mbfs-button">{{ 'Dashboard.ProfileButton' | translate }}</button>
              </div>
              <br><br>
            </div>
        </div>
      </div>
    </div>
    <!-- <div class="dtfbrochures__containerlong">
      <h4 class="dtfbrochures__title">{{ 'Dashboard.InsuranceTitle' | translate }}</h4>
      <div class="row">
        <img class="iconimage3" src="static/assets/img/dtf-assets/images/redesign/Payment-Program-Icon.png">
        <h4 class="dtfbrochures__header3">{{ 'Dashboard.InsuranceHeader' | translate }}</h4>
      </div>
     <div class="row3">
      <p class="dtfbrochures__paragraph1">{{ 'Dashboard.InsuranceCopy' | translate }}</p>
      <button type="submit" (click)="checkUrl('insurance')" class="mbfs-button">{{ 'Dashboard.InsuranceButton' | translate }}</button>
    </div>
     <br><br>
   </div> -->
 </div>

 <!--Canada HTML page-->
 <div class="container_dashboard" *ngIf="!this.bodyLoaded && isCanadaPortal && !isTerminatedAccounts">
  <div class="dtfbrochures__containerlong">
    <div class="row4">
      <div class="dynamicflexbox">
        <section class="section">
          <div class="section__item section__item--start">
              <h4 class="dtfbrochures__header5">{{ 'Dashboard.NumAccounts' | translate }}</h4>
              <div style="margin-left: 40px;" *ngIf="newAccount">
                <img matSuffix class="example-form-img" src="static/assets/img/dtf-assets/images/DTF_Icons/NewFlag.png">
              </div>
              <h3 class="dtfbrochures__header7">{{this.recAccCount}}</h3>
              <button type="submit" (click)="checkUrl('account')" [routerLink]="[]" class="mbfs-button">{{ 'Dashboard.AdditionalDetails' | translate }}</button>
          </div>
          <div class="section__item section__item--end">
              <h4 class="dtfbrochures__header5">{{ 'Dashboard.CurrentDue' | translate }}</h4>
              <h3 class="dtfbrochures__header6">${{this.totalDue}}</h3>
              <button type="submit"(click)="checkUrl('pay')" class="mbfs-button">{{ 'Dashboard.PayNowButton' | translate }}</button>
          </div>
        </section>
      </div>
    </div>
  </div>

  <!-- <div class="dtfbrochures__containerlong2">
    <div class="dynamicflexbox">
       <section class="section1">
          <div class="section__item section__item--start"></div>
          <div class="section__item section__item--end">
             <h4 class="dtfbrochures__header4" style="color: white;"> {{ 'Dashboard.NewAccountTitle' | translate }}</h4>
             <p class="dtfbrochures__paragraph2" style="color: white;">{{ 'Dashboard.NewAccountCopy' | translate }} </p>
          </div>
       </section>
    </div>
 </div> -->
  <div class="row">
     <div class="col-sm-6">
        <div class="">
          <div class="card-body1">
            <h4 class="dtfbrochures__title">{{ 'Dashboard.PayoffTitle' | translate }}</h4>
              <div class="row">
                 <img class="iconimage3" src="static/assets/img/dtf-assets/images/redesign/Get-a-Payoff-Icon.png">
                 <h4 class="dtfbrochures__header3">{{ 'Dashboard.PayoffHeader' | translate }}</h4>
              </div>
              <div class="row2">
                <p class="dtfbrochures__paragraph1">{{ 'Dashboard.PayoffCopy' | translate }}</p>
                <button type="submit" (click)="checkUrl('payoff')" class="mbfs-button">{{ 'Dashboard.PayoffButton' | translate }}</button>
              </div>
              <br><br>
           </div>
        </div>
     </div>
     <div class="col-sm-6">
        <div class="">
          <div class="card-body1">
            <h4 class="dtfbrochures__title">{{ 'Dashboard.PaymentTitle' | translate }}</h4>
              <div class="row">
                 <img class="iconimage3" src="static/assets/img/dtf-assets/images/redesign/View-Payment-History-Icon.png">
                 <h4 class="dtfbrochures__header3">{{ 'Dashboard.PaymentHeader' | translate }}</h4>
              </div>
              <div class="row2">
                <p class="dtfbrochures__paragraph1">{{ 'Dashboard.PaymentCopy' | translate }}</p>
                <button type="submit" (click)="paymenthistoryCA()" class="mbfs-button">{{ 'Dashboard.PaymentButton' | translate }}</button>
              </div>
              <br><br>
           </div>
        </div>
     </div>
  </div>
  <div class="row">

    <div class="col-sm-6">
       <div class="">
        <div class="card-body1">
          <h4 class="dtfbrochures__title">{{ 'Dashboard.AmortTitle' | translate }}</h4>
          <div class="row">
                <img class="iconimage3" src="static/assets/img/dtf-assets/images/redesign/View-Amortization-Schedule-Icon.png">
                <h4 class="dtfbrochures__header3">{{ 'Dashboard.AmortHeader' | translate }}</h4>
             </div>
             <div class="row2">
              <p class="dtfbrochures__paragraph1">{{ 'Dashboard.AmortCopy' | translate }}</p>
              <button type="submit" (click)="checkUrl('amortization')" class="mbfs-button">{{ 'Dashboard.AmortButton' | translate }}</button>
             </div>
             <br><br><br>
          </div>
       </div>
    </div>
    <div class="col-sm-6">
      <div class="">
        <div class="card-body1">
          <h4 class="dtfbrochures__title">{{ 'Dashboard.InvoiceTitle' | translate }}</h4>
            <div class="row">
                <img class="iconimage3" src="static/assets/img/dtf-assets/images/redesign/View-Your-Invoices-Icon.png">
                <h4 class="dtfbrochures__header3">{{ 'Dashboard.InvoiceHeader' | translate }}</h4>
            </div>
            <div class="row2">
              <p class="dtfbrochures__paragraph1">{{ 'Dashboard.InvoiceCopy' | translate }}</p>
              <!-- <button type="submit" (click)="checkUrl('invoice')" class="mbfs-button">{{ 'Dashboard.InvoiceButton' | translate }}</button> -->
              <button type="submit" (click)="checkUrl('documentcenter')" class="mbfs-button">{{ 'Dashboard.DocumentCenterButton' | translate }}</button>
            </div>
            <br><br>
          </div>
      </div>
    </div>
  </div>
  
    <div class="row">
     
    <div class="col-sm-6">
      <div class="">
        <div class="card-body1">
          <h4 class="dtfbrochures__title">{{ 'Dashboard.ProfileTitle' | translate }}</h4>
            <div class="row">
                <img class="iconimage3" src="static/assets/img/dtf-assets/images/redesign/Manage-Your-Profile-Icon.png">
                <h4 class="dtfbrochures__header3">{{ 'Dashboard.ProfileHeader' | translate }}</h4>
            </div>
            <div class="row2">
              <p class="dtfbrochures__paragraph1">{{ 'Dashboard.ProfileCopy' | translate }}</p>
              <button type="submit" (click)="checkUrl('manageYourProfile')" class="mbfs-button">{{ 'Dashboard.ProfileButton' | translate }}</button>
            </div>
            <br><br>
          </div>
      </div>
    </div>

    <div class="col-sm-6">
      <div class="">
        <div class="card-body1">
          <h4 class="dtfbrochures__title">{{ 'Dashboard.EbillButton' | translate }}</h4>
          <div class="row">
             <img class="iconimage3" src="static/assets/img/dtf-assets/images/redesign/Manage-AutoPay-Icon.png">
             <h4 class="dtfbrochures__header3">{{ 'Dashboard.EbillButton' | translate }}</h4>
           </div>
          <div class="row2">
           <p></p>
           <button type="submit" (click)="checkUrl('ebill')" class="mbfs-button">{{ 'Dashboard.EbillButton' | translate }}</button>
          </div>
         <br><br>
          <br><br>
        </div>
          
      </div>
   </div>
  </div>
  <div class="dtfbrochures__containerlong">
    <h4 class="dtfbrochures__title">{{ 'Dashboard.InsuranceTitle' | translate }}</h4>
    <div class="row">
      <img class="iconimage3" src="static/assets/img/dtf-assets/images/redesign/Payment-Program-Icon.png">
      <h4 class="dtfbrochures__header3">{{ 'Dashboard.InsuranceHeader' | translate }}</h4>
    </div>
   <div class="row3">
    <p class="dtfbrochures__paragraph1">{{ 'Dashboard.InsuranceCopy' | translate }}</p>
    <button type="submit" (click)="checkUrl('insurance')" class="mbfs-button">{{ 'Dashboard.InsuranceButton' | translate }}</button>
  </div>
   <br><br>
 </div>
</div>

  <!-- Terminated Accounts US HTML Page -->
  <div class="container_dashboard" *ngIf="isTerminatedAccounts && !isCanadaPortal && !this.bodyLoaded">
      <div class="dtfbrochures__containerlong">
      <div class="row4">
        <div class="dynamicflexbox">
        <div style="text-align: right;">
          <a (click)="clickvideo('viewAccounts');" href="javascript:void(0);" > <img style="width: 30px;" src="/static/assets/img/dtf-assets/images/redesign/DTF_Website_VideoHelpButton.png"></a>
        </div>

          <section class="section">
            <div class="section__item section__item--start">
                <h4 class="dtfbrochures__header5">{{ 'Dashboard.NumAccounts' | translate }}</h4>
                <div style="margin-left: 40px;" *ngIf="newAccount">
                  <img matSuffix class="example-form-img" src="static/assets/img/dtf-assets/images/DTF_Icons/NewFlag.png">
                </div>
                <h3 class="dtfbrochures__header7">{{this.recAccCount}}</h3>
                <button type="submit" (click)="checkUrl('account')" [routerLink]="[]" class="mbfs-button">{{ 'Dashboard.AdditionalDetails' | translate }}</button>
            </div>
            <div class="section__item section__item--end">
                <h4 class="dtfbrochures__header5">{{ 'Dashboard.CurrentDue' | translate }}</h4>
                <h3 class="dtfbrochures__header6">${{this.totalDue}}</h3><!--{{'Dashboard.CurrentDueValue'}}-->
                <button *ngIf="DTPAY && getTotalDueValue() > 0" type="submit" (click)="checkUrlPay('terminatedaccountpayment')" class="mbfs-button">{{ 'Dashboard.PayNowButton' | translate }}</button>
            </div>
          </section>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-6">
        <div class="">
          <div class="card-body1">
            <div style="text-align: right;">
              <a (click)="clickvideo('invoice');" href="javascript:void(0);"> <img style="width: 30px;"
                  src="/static/assets/img/dtf-assets/images/redesign/DTF_Website_VideoHelpButton.png"></a>
            </div>
            <h4 class="dtfbrochures__title">{{ 'Dashboard.InvoiceTitle' | translate }} </h4>
            <div class="row">
              <img class="iconimage3" src="static/assets/img/dtf-assets/images/redesign/Doc-Request-Icon.png">
              <h4 class="dtfbrochures__header3">{{ 'Dashboard.InvoiceHeader' | translate }}</h4>
            </div>
            <div class="row2">
              <p class="dtfbrochures__paragraph1">{{ 'Dashboard.InvoiceCopy' | translate }}</p>
              <!-- <button type="submit" (click)="checkUrl('invoice')" class="mbfs-button">{{ 'Dashboard.InvoiceButton' | translate }}</button> -->
              <button type="submit" (click)="checkUrl('documentcenter')" class="mbfs-button">{{
                'Dashboard.DocumentCenterButton' | translate }}</button>
            </div>
            <br><br>
          </div>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="">
          <div class="card-body1">
            <div style="text-align: right;">
              <a (click)="clickvideo('profile');" href="javascript:void(0);"> <img style="width: 30px;"
                  src="/static/assets/img/dtf-assets/images/redesign/DTF_Website_VideoHelpButton.png"></a>
            </div>
            <h4 class="dtfbrochures__title">{{ 'Dashboard.ProfileTitle' | translate }} </h4>
            <div class="row">
              <img class="iconimage3" src="static/assets/img/dtf-assets/images/redesign/Manage-Your-Profile-Icon.png">
              <h4 class="dtfbrochures__header3">{{ 'Dashboard.ProfileHeader' | translate }}</h4>
            </div>
            <div class="row2">
              <p class="dtfbrochures__paragraph1">{{ 'Dashboard.ProfileCopy' | translate }}</p>
              <button type="submit" (click)="checkUrl('manageYourProfile')" class="mbfs-button">{{
                'Dashboard.ProfileButton' | translate }}</button>
            </div>
            <br><br>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  <!-- Terminated Accounts CA HTML Page -->
  <div class="container_dashboard" *ngIf="isTerminatedAccounts && isCanadaPortal && !this.bodyLoaded">
    <div class="dtfbrochures__containerlong">
      <div class="row4">
        <div class="dynamicflexbox">
          <section class="section">
            <div class="section__item section__item--start">
              <h4 class="dtfbrochures__header5">{{ 'Dashboard.NumAccounts' | translate }}</h4>
              <div style="margin-left: 40px;" *ngIf="newAccount">
                <img matSuffix class="example-form-img" src="static/assets/img/dtf-assets/images/DTF_Icons/NewFlag.png">
              </div>
              <h3 class="dtfbrochures__header7">{{this.recAccCount}}</h3>
              <button type="submit" (click)="checkUrl('account')" [routerLink]="[]" class="mbfs-button">{{
                'Dashboard.AdditionalDetails' | translate }}</button>
            </div>
            <div class="section__item section__item--end">
              <h4 class="dtfbrochures__header5">{{ 'Dashboard.CurrentDue' | translate }}</h4>
              <h3 class="dtfbrochures__header6">${{this.totalDue}}</h3>
            </div>
          </section>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-6">
        <div class="">
          <div class="card-body1">
            <div style="text-align: right;">
              <a (click)="clickvideo('invoice');" href="javascript:void(0);"> <img style="width: 30px;"
                  src="/static/assets/img/dtf-assets/images/redesign/DTF_Website_VideoHelpButton.png"></a>
            </div>
            <h4 class="dtfbrochures__title">{{ 'Dashboard.InvoiceTitle' | translate }} </h4>
            <div class="row">
              <img class="iconimage3" src="static/assets/img/dtf-assets/images/redesign/Doc-Request-Icon.png">
              <h4 class="dtfbrochures__header3">{{ 'Dashboard.InvoiceHeader' | translate }}</h4>
            </div>
            <div class="row2">
              <p class="dtfbrochures__paragraph1">{{ 'Dashboard.InvoiceCopy' | translate }}</p>
              <!-- <button type="submit" (click)="checkUrl('invoice')" class="mbfs-button">{{ 'Dashboard.InvoiceButton' | translate }}</button> -->
              <button type="submit" (click)="checkUrl('documentcenter')" class="mbfs-button">{{
                'Dashboard.DocumentCenterButton' | translate }}</button>
            </div>
            <br><br>
          </div>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="">
          <div class="card-body1">
            <div style="text-align: right;">
              <a (click)="clickvideo('profile');" href="javascript:void(0);"> <img style="width: 30px;"
                  src="/static/assets/img/dtf-assets/images/redesign/DTF_Website_VideoHelpButton.png"></a>
            </div>
            <h4 class="dtfbrochures__title">{{ 'Dashboard.ProfileTitle' | translate }} </h4>
            <div class="row">
              <img class="iconimage3" src="static/assets/img/dtf-assets/images/redesign/Manage-Your-Profile-Icon.png">
              <h4 class="dtfbrochures__header3">{{ 'Dashboard.ProfileHeader' | translate }}</h4>
            </div>
            <div class="row2">
              <p class="dtfbrochures__paragraph1">{{ 'Dashboard.ProfileCopy' | translate }}</p>
              <button type="submit" (click)="checkUrl('manageYourProfile')" class="mbfs-button">{{
                'Dashboard.ProfileButton' | translate }}</button>
            </div>
            <br><br>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  </div>